import React from "react"

import { Wrapper, Row, ColWithBg, Content } from "../pageElements"

export const Instagram = () => {
  return (
    <Wrapper>
      <Row height={20}>
        <ColWithBg>
          <Content center>INSTAGRAM</Content>
        </ColWithBg>
      </Row>
    </Wrapper>
  )
}
